/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   5/20/21 12:55 PM
 */

import { format as formatDate } from "./dates-helper"

export function generateSafeRandomString(length: number) {
	let result = '';
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	for ( let i = 0; i < length; i++ ) {
		result += chars.charAt(Math.floor(Math.random() * chars.length));
	}
	return result;
}

export function toCamelCase(string: string) {
	return string
		.replace(/\.?([A-Z])/g,  (x,y) => "_" + y.toLowerCase())
		.replace(/^_/, "");
}

export function getAttributeLabel(attribute: string) {
	return (attribute
		.replace(/^[\s_]+|[\s_]+$/g, '')
		.replace(/[_\s]+/g, ' ')
		.match(/[A-Za-z][a-z]*/g) || [])
		.map(w => w.replace(/^[a-z]/, m => m.toUpperCase() ))
		.map(w => ["Id", "Db", "Ip", "Url"].includes(w) ? w.toUpperCase() : w)
		.join(" ");
}

export function formatValue(format: string | undefined, value: any) {
	if (value === null || value === undefined) return value;
	switch (format) {
		case "date":
			return formatDate(new Date(value), 'P');
		case "datetime":
			return formatDate(new Date(value), 'P p');
		case "currency":
			return "$" + Math.round(value * 10) / 10;
		case "number(1)":
			return Math.round(value * 10) / 10;
		case "number(2)":
			return Math.round(value * 100) / 100;
		case "size":
			value = Number(value);
			if (value < 1024) return value + " B";
			else if (value < 1024**2) return Math.round(value / 1024) + " KB";
			else if (value < 1024**3) return Math.round(value / 1024**2) + " MB";
			else if (value < 1024**4) return Math.round(value / 1024**3) + " GB";
			return value;
		case "boolean":
			return value ? "Yes" : "No";
		default:
			return value;
	}
}